export default __webpack_public_path__ + "static/media/image_efficacy.f9a680a1.svg";